import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { EntityProfileHeaderAddNewButton } from '../../../Entity'
import { isUserProfileActionAddNew } from '../../../User'
import {
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_TEXT_KEY,
  USER_PROFILE_PAGE_HEADER_FOOTER_PRIMARY_ACTION_QA_NAME,
  USER_PROFILE_PAGE_HEADER_FOOTER_QA_NAME,
} from '../UserProfilePageHeaderFooter.constants'

function UserProfilePageHeaderFooterPrimaryAction({
  actionHandlers,
  addNewOptions,
  primaryAction,
  onSelectOption,
}) {
  const { t } = useTranslation()

  return isUserProfileActionAddNew(primaryAction) ? (
    <EntityProfileHeaderAddNewButton
      buttonProps={{
        qaName: USER_PROFILE_PAGE_HEADER_FOOTER_QA_NAME.addNew,
      }}
      dropdownFloatingConfig={{ maxWidthByRef: false }}
      options={addNewOptions}
      onSelectItem={onSelectOption}
    />
  ) : primaryAction ? (
    <Button.Contained
      qaName={
        USER_PROFILE_PAGE_HEADER_FOOTER_PRIMARY_ACTION_QA_NAME[primaryAction]
      }
      text={t(USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_TEXT_KEY[primaryAction])}
      onClick={actionHandlers[primaryAction]}
    />
  ) : null
}

export default UserProfilePageHeaderFooterPrimaryAction
